import React from 'react';
import { useSharkSettings } from './hooks/useSharkSettings';
import { SharkHeader } from './components/SharkHeader';
import { ChooseSharkCard } from './components/ChooseSharkCard';
import { SharkAccessoriesCard } from './components/SharkAccessoriesCard';
import { SharkPreviewCard } from './components/SharkPreviewCard';

export function SharkSettings() {
  const {
    shark,
    setShark,
    direction,
    setDirection,
    currentIndex,
    currentShark,
    currentCostumeObj,
    navigateShark,
    handleSave,
    isSaving
  } = useSharkSettings();

  return (
    <div style={{ width: '100%', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <style>{`
        @media (max-width: 840px) {
          .shark-settings-grid {
            grid-template-columns: 1fr !important;
          }
          .shark-header-container {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 12px !important;
          }
          .shark-header-title {
            font-size: 28px !important;
            line-height: 32px !important;
          }
          .shark-save-btn {
            width: 100% !important;
            justify-content: center !important;
          }
          .shark-preview-top-section {
            display: none !important;
          }
          .shark-name-section {
            border-top: none !important;
            padding-top: 0 !important;
            margin-top: 0 !important;
          }
        }
        @media (max-width: 480px) {
          .shark-frame-box {
            height: 180px !important;
            padding: 12px !important;
          }
          .shark-accessory-text {
            font-size: 9px !important;
          }
          .shark-accessory-item {
            padding: 10px 4px !important;
          }
        }
      `}</style>
      
      {/* ── Header ── */}
      <SharkHeader onSave={handleSave} isSaving={isSaving} />

      {/* ── Main Two-Column Layout (Responsive) ── */}
      <div 
        className="shark-settings-grid"
        style={{ display: 'grid', gridTemplateColumns: '1fr 340px', gap: '16px', alignItems: 'stretch' }}
      >
        {/* ── Left Column: Shark Carousel + Accessories ── */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', height: '100%', justifyContent: 'space-between' }}>
          
          <div id="tour-shark-select">
            <ChooseSharkCard
              currentIndex={currentIndex}
              currentShark={currentShark}
              currentCostumeObj={currentCostumeObj}
              direction={direction}
              onNavigate={navigateShark}
              onSelectSpecies={(speciesId, isNext) => {
                setDirection(isNext ? 1 : -1);
                setShark(prev => ({ ...prev, species: speciesId }));
              }}
            />
          </div>

          <div id="tour-shark-costumes">
            <SharkAccessoriesCard
              currentShark={currentShark}
              selectedCostume={shark.costume}
              onSelectCostume={(costumeId) => setShark(prev => ({ ...prev, costume: costumeId }))}
            />
          </div>
        </div>

        {/* ── Right Column: Preview & Name ── */}
        <div id="tour-shark-preview">
          <SharkPreviewCard
            sharkName={shark.name}
            currentShark={currentShark}
            currentCostumeObj={currentCostumeObj}
            onNameChange={(name) => setShark(prev => ({ ...prev, name }))}
          />
        </div>

      </div>
    </div>
  );
}
